import { useMemo } from 'react';
import { buildColumnsWithRenderers } from '../config/columns';
import { createTrackingDateRenderer, createStyledCellRenderer, createRowHeaderRenderer } from '../renderers';
import { getBaseTableSettings } from '../config/handsontable';

interface UseTableSettingsParams {
  fields: any[] | undefined;
  tableData: any[];
  shipmentsMap: Record<string, any>;
  trackingJobsMap: Record<string, any>;
  hotRef: any;
}

export const useTableSettings = ({ fields, tableData, shipmentsMap, trackingJobsMap }: UseTableSettingsParams) => {
  // Renderers
  const trackingDateRenderer = useMemo(() => createTrackingDateRenderer({ shipmentsMap }), [shipmentsMap]);

  const styledCellRenderer = useMemo(() => createStyledCellRenderer({ shipmentsMap }), [shipmentsMap]);

  const rowHeaderRenderer = useMemo(() => createRowHeaderRenderer({ trackingJobsMap }), [trackingJobsMap]);

  // Columns
  const columns = useMemo(() => {
    if (!fields?.length) return [];
    return buildColumnsWithRenderers(fields, trackingDateRenderer, styledCellRenderer);
  }, [fields, trackingDateRenderer, styledCellRenderer]);

  // Settings
  const settings = useMemo(() => {
    if (!columns.length) return null;

    return {
      ...getBaseTableSettings(),
      data: tableData,
      columns,
      multiColumnSorting: true,
      dropdownMenu: ['filter_by_condition', 'filter_by_value', 'filter_action_bar'] as any,
      filters: true,
      rowHeaders: true,
      afterGetRowHeader: rowHeaderRenderer,
      cells: () => ({ editor: false }),
    };
  }, [columns, tableData, rowHeaderRenderer]);

  return { settings, columns };
};
